import util from "@/libs/util.js"
import { AccountLogin, getAuths, getUserInfo } from "@api/sys.account"
// import { SUPPER_ADMIN } from '@/common/constants'
import { localRoutes } from "@/router/routes"
import md5 from "js-md5"
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({ dispatch, commit }, p) {
      // console.log(router.addRoutes);
      return new Promise((resolve, reject) => {
        var params = {
          userName: p.userName,
          password: md5(p.password).toLowerCase()
        }
        // 开始请求登录接口
        AccountLogin(params)
          .then(async (accountInfo = {}) => {
            // 设置 cookie 一定要存 uuid 和 token 两个 cookie
            // 整个系统依赖这两个数据进行校验和存储
            // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
            // token 代表用户当前登录状态 建议在网络请求中携带 token
            // 如有必要 token 需要定时更新，默认保存一天
            // util.cookies.set('uuid', accountInfo.loginName)
            if (accountInfo.accountList.length > 1) {
              resolve({
                isMutiAccount: true,
                accountInfo: accountInfo,
                userInfo: {}
              })
            } else {
              console.log(accountInfo, "accountInfo")
              util.cookies.set("token", accountInfo.sessionId)
              dispatch(
                "d2admin/user/actionSetScrmInfo",
                {
                  sessionId: accountInfo.sessionId,
                  merchantId: accountInfo.accountList[0].merchantNo
                },
                { root: true }
              )
              // .then((response) => {
              //   console.log("Action成功:", response)
              // })
              // .catch((error) => {
              //   console.error("Action失败:", error)
              // })
              // actionSetScrmInfo({ sessionId: res.sessionId, merchantId: +currentItem.merchantNo })
              getUserInfo({}).then(async (userInfo) => {
                userInfo.beSuper = userInfo.loginAccount.isAdmin == 1
                if (userInfo.beSuper) {
                  // 是否园区店
                  userInfo.beYQMerchant = true
                  // 是否服务商
                  userInfo.beServerMerchant = true
                } else {
                  // 是否园区店
                  userInfo.beYQMerchant =
                    userInfo.loginAccount.merchantAccountList.includes("6") ||
                    userInfo.loginAccount.merchantAccountList.includes("8")
                  // 是否服务商
                  userInfo.beServerMerchant =
                    userInfo.loginAccount.merchantAccountList.includes("7")
                }
                userInfo.detail = userInfo.merchant
                Object.keys(userInfo.loginAccount).forEach((item) => {
                  if (userInfo.loginAccount[item] && !userInfo.detail[item]) {
                    userInfo.detail[item] = userInfo.loginAccount[item]
                  }
                })
                userInfo.merchantAccountLevel =
                  userInfo.detail.merchantAccountLevel
                await dispatch("getAuth", {
                  userInfo: userInfo,
                  accountInfo: accountInfo
                })
                resolve({
                  isMutiAccount: false,
                  accountInfo: accountInfo,
                  userInfo: userInfo
                })
              })
            }
          })
          .catch((err) => {
            console.log("err: ", err)
            reject(err)
          })
      })
    },
    /**
     * @description 获取用户权限
     * @param {*} param0
     * @param {*} param1
     */
    getAuth({ commit, dispatch }, { userInfo, accountInfo }) {
      return new Promise((resolve, reject) => {
        getAuths({}).then(async (res) => {
          userInfo.detail.merchantId = userInfo.detail.merchantNo
          var routeAll = util.permision.flatten(Object.values(localRoutes))

          // var indexPage = routeAll.find((item) => item.authId === "907")
          // routeAll.splice(
          //   routeAll.findIndex((item) => item.authId === "907"),
          //   1
          // )
          // routeAll.unshift(indexPage)

          // console.log(routeAll, "routeAll")

          // if (userInfo.detail.accountType !== 7) {
          //   !res.map((i) => i.authId).includes("907") &&
          //     res.unshift({
          //       authId: "907",
          //       name: "总览",
          //       parentId: "1"
          //     })
          // }
          var tempAuths = []
          // 修复超管拿不到权限权限问题
          var targetRoutes = res.map((i) => i.authId)
          // var targetRoutes = userInfo.beSuper
          //   ? routeAll.map((i) => i.authId)
          //   : res.map((i) => i.authId)

          // if (targetRoutes.length === 0) {
          //   this.$message.warning("无权限,请联系管理员")
          //   return reject("无权限")
          // }
          // console.log(res, "res")
          // console.log(userInfo.beSuper, "userInfo.beSuper")
          // console.log(targetRoutes, "targetRoutes")

          // 先处理园区店角色是不能拿到 订单审批和发货的页面
          // console.log("userInfo.beYQMerchant", userInfo.beYQMerchant)
          // const filterList = ["90903", "90904"]
          // if (!userInfo.beSuper && userInfo.beYQMerchant) {
          //   targetRoutes = targetRoutes.filter((item) => {
          //     return !filterList.includes(item.toString())
          //   })
          // }
          // if (userInfo.beServerMerchant) {
          //   targetRoutes.push("90904")
          // }
          // console.log("targetRoutes", targetRoutes)

          // routeAll
          //   .map((i) => i.authId)
          //   .forEach((item, index) => {
          //     targetRoutes.includes(item) && tempAuths.push(routeAll[index])
          //     if (routeAll[index].hasOwnProperty("addRoutePath")) {
          //       routeAll[index].addRoutePath.forEach((k) => {
          //         if (!tempAuths.map((m) => m.authId).includes(k.authId)) {
          //           tempAuths.push(k)
          //         }
          //       })
          //     }
          //   })
          // let routeAllId =  routeAll.map((i) => i.authId)
          targetRoutes.forEach((item) => {
            // routeAll.
            // if (!routeAll.map((i) => i.authId).includes(item))
            const authInfo = routeAll.find((ele) => {
              return ele.authId === item
            })
            // console.log(authInfo, "authInfo")
            authInfo && tempAuths.push(authInfo)
            // console.log(authInfo && authInfo.hasOwnProperty("addRoutePath"))
            if (authInfo && authInfo.hasOwnProperty("addRoutePath")) {
              // authInfo.
              authInfo.addRoutePath.forEach((k) => {
                if (!tempAuths.map((m) => m.authId).includes(k.authId)) {
                  tempAuths.push(k)
                }
              })
            }
          })
          // tempAuths.
          var indexPage = tempAuths.find((item) => item.authId === "907")
          if (indexPage) {
            tempAuths.splice(
              tempAuths.findIndex((item) => item.authId === "907"),
              1
            )
            tempAuths.unshift(indexPage)
          }
          // var ind = tempAuths.findIndex((item) => item.authId === "907")
          // if (ind) {
          //   tempAuths = [
          //     tempAuths[ind],
          //     ...tempAuths.filter((item) => item.authId !== "907")
          //   ]
          // }

          // const authes = (+accountInfo.roleType === SUPPER_ADMIN) ?
          //   util.permision.flatten(Object.values(localRoutes))
          //   .map(obj => ({ authId: obj.authId, parentId: obj.parentId })) :
          //   tempAuths
          // console.log(tempAuths)
          // console.log("tempAuths", tempAuths)
          // debugger
          const authes = tempAuths
          await dispatch("d2admin/auth/set", authes, { root: true })
          // delete accountInfo.authes
          // 初始化权限
          await dispatch("d2admin/auth/init", null, { root: true })
          // // 设置 vuex 用户信息
          await dispatch(
            "d2admin/user/set",
            { info: userInfo, accountInfo },
            { root: true }
          )
          // // 用户登录后从持久化数据加载一系列的设置
          await dispatch("load")
          // 结束
          resolve(userInfo)
        })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      return new Promise(async (resolve) => {
        // 删除cookie
        // util.cookies.remove('uuid')
        await dispatch("d2admin/user/clear", null, { root: true })
        await dispatch("d2admin/base/clear", null, { root: true })
        // await commit('d2admin/page/setCurrent', null, { root: true })
        // await commit('d2admin/auth/set', null, { root: true })
        resolve()
      })
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load({ dispatch }) {
      return new Promise(async (resolve) => {
        // DB -> store 加载用户名
        await dispatch("d2admin/user/load", null, { root: true })
        // DB -> store 加载下载列表
        await dispatch("d2admin/user/downLoadListLoad", "dowloadList", {
          root: true
        })
        await dispatch("d2admin/user/downLoadListLoad", "updateList", {
          root: true
        })
        // DB -> store 加载主题
        await dispatch("d2admin/theme/load", null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch("d2admin/transition/load", null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch("d2admin/page/openedLoad", null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch("d2admin/menu/asideCollapseLoad", null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch("d2admin/size/load", null, { root: true })
        // DB - > 初始化 基础数据
        await dispatch("d2admin/base/init", null, { root: true })
        // 后台接口 -> store
        // await dispatch('d2admin/auth/init', null, { root: true })
        // end
        dispatch("d2admin/user/getScrmInfoLoad", null, {
          root: true
        })
        resolve()
      })
    }
  }
}
